// AIP -> Adinplay ads a 3rd parth ad network https://adinplay.com/
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIAIPAdController {
    startRefreshing() {
        if (UIUtilsEjsVariables.showVliAdAtBottomInGame == true) return;
        this.timer = setInterval(()=>{
            this.refreshAIPAdIfShowing();
        }, this.UPDATE_AD_DURATION);
    }
    stopRefreshing() {
        if (this.timer == undefined) return;
        clearInterval(this.timer);
    }
    refreshAIPAdIfShowing() {
        if (this.adElements.containerGameBottomSmall == undefined) return;
        if (window.getComputedStyle(this.adElements.containerGameBottomSmall).display == 'none') return;
        if (refreshAIPAd == undefined) return;
        refreshAIPAd(this.AIP_GAME_BOTTOM_SMALL);
    }
    constructor(adElements){
        this.UPDATE_AD_DURATION = 1000 * 30;
        this.AIP_GAME_BOTTOM_SMALL = 'colonist-io_728x90_2';
        this.adElements = adElements;
    }
}
